import _ from "lodash";

export default (obj, key, defaultValue = null) => (_.isNil(obj) || _.isNil(obj[key]) ? defaultValue : obj[key]);
